import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Backdrop, Box, Button } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import * as Yup from "yup";
import { useFormik } from "formik";
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import CheckPermissions from '../../../authorization/authorization';
import AdminCompanySelect from '../../../components/AdminCompanySelect/AdminCompanySelect';
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
import { companyShortName, convertDatewithTime } from '../../../services/Functions';
import { tableStyle } from '../../../style/common';
import useAdminOrgCompanyFilter, {
    filterOrgRowsByCompany,
} from '../hooks/useAdminOrgCompanyFilter';
import '../OrganizationManagement.scss';
import '../OrgEntityDetailsDialog.scss';
import SearchIcon from '@mui/icons-material/Search';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Snackbar, Alert } from '@mui/material';
import Error from '../../../components/error/error';

const displayValue = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
};

const formatDetailDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined || dateValue === '') return '-';
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime()) || date.getFullYear() < 1971) return '-';
    return convertDatewithTime(dateValue);
};

const isDivisionActive = (status) => status === '0' || status === 'active';

const DetailField = ({ label, value }) => {
    const text = displayValue(value);
    return (
        <div className="org-details-dialog__field">
            <span className="org-details-dialog__label">{label}</span>
            <p className={`org-details-dialog__value${text === '-' ? ' org-details-dialog__value--muted' : ''}`}>
                {text}
            </p>
        </div>
    );
};

const DetailSection = ({ title, children }) => (
    <section className="org-details-dialog__section">
        <div className="org-details-dialog__section-header">
            <span className="org-details-dialog__section-accent" />
            <h4>{title}</h4>
        </div>
        <div className="org-details-dialog__grid">{children}</div>
    </section>
);

export default function DivisionManagementTable(props) {
    //#region 
    const [divisionsToDataGrid, setDivisionsToDataGrid] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltDivision, setDltDivision] = useState()
    const [tableDivision, setTableDivision] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(true);
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [apiError, setApiError] = useState('')
    const Navigate = useNavigate();
    const errorCloses = () => {
        setApiError("")
    };
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)
    const {
        isAdminUser,
        selectedCompanyCode,
        handleChangeCompany,
        getHierarchyApiScopeCode,
    } = useAdminOrgCompanyFilter();

    //#endregion
    useEffect(() => {
        if (!tableDataLoaded) return;
        apiToDataGridConversion();
        setViewBackdrop(false);
    }, [tableDivision, tableDataLoaded]);

    useEffect(() => {
        const callAllDivisionsAPI = async () => {
            setViewBackdrop(true);
            setTableDataLoaded(false);

            if (isAdminUser && !selectedCompanyCode) {
                setTableDivision([]);
                setTableDataLoaded(true);
                return;
            }

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                circleCode: isAdminUser
                    ? getHierarchyApiScopeCode()
                    : parseInt(userOfficeCode.toString().slice(0, 3)),
                pageNumber: 1,
                pageSize: 9999,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/getDivisionDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        const rows = filterOrgRowsByCompany(
                            result.data,
                            isAdminUser,
                            selectedCompanyCode,
                            "circleCode",
                        );
                        setTableDivision(rows);
                    } else if (result.status === "401" && result.message === "Session has been expired, Sign in again.") {
                        Navigate('/')
                    } else {
                        setTableDivision([]);
                    }
                })
                .catch(() => {
                    setTableDivision([]);
                });
            setTableDataLoaded(true);
        }
        callAllDivisionsAPI()
    }, [selectedCompanyCode, userOfficeCode, isAdminUser])
    const initialValues = {
        iv_divBankName: '',
        iv_divisionERPCode: '',
        iv_divCapitalCostAccountNo: '',
        iv_divSecurityAccountNo: '',
        iv_remarks: '',
    }
    const bankdetailsFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_divBankName: Yup.string()
                .max(100, 'Bank name cannot exceed 100 characters.')
                .min(10, 'Bank name must be at least 10 characters long.')
                .required('Bank name is required.'),

            iv_divisionERPCode: Yup.string()
                .required('ERP code is required.'),

            iv_divCapitalCostAccountNo: Yup.string()
                .min(10, 'Capital cost account no. must be at least 10 characters long.')
                .required('Capital cost account no. is required.'),

            iv_divSecurityAccountNo: Yup.string()
                .min(10, 'Security account no. must be at least 10 characters long.')
                .required('Security account no. is required.'),

            iv_remarks: Yup.string()
                .max(100, 'Remarks cannot exceed 100 characters.')
                .required('Remarks are required.')
        }),

        onSubmit: async (values, { resetForm }) => {
            // setViewBackdrop(true);
            // const myHeaders = new Headers();
            // myHeaders.append("Authorization", token);
            // myHeaders.append("Content-Type", "application/json");

            // const raw = JSON.stringify({
            //     "userId": selectedUserId,
            //     "password": values.iv_new_password,
            //     "remarks": values.iv_remarks,
            // });

            // const requestOptions = {
            //     method: "POST",
            //     headers: myHeaders,
            //     body: raw,
            //     redirect: "follow"
            // };

            // await fetch(cfpBaseUrl + "customerFaciliationPortal/changePasswordofUser", requestOptions)
            //     .then((response) => response.json())
            //     .then((result) => {
            //         if (result.status === "200") {
            //             resetForm();
            //             setShowChangePasswordPopup(false)
            //             setShowSuccessSnackbar(true);
            //             setTimeout(() => {
            //                 setShowChangePasswordPopup(false);
            //             }, 300);
            //         } else if (result.status === "400") {
            //             setApiError(result.message)
            //         }
            //     })
            //     .catch(() => {});
            // setViewBackdrop(false);
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "divisionCode": selectedUserId,
                "divisionERPCode": values.iv_divisionERPCode,
                "divBankName": values.iv_divBankName,
                "divCapitalCostAccountNo": values.iv_divCapitalCostAccountNo,
                "divSecurityAccountNo": values.iv_divSecurityAccountNo,
                "remarks": values.iv_remarks
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/updateDivisionBankDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        resetForm();
                        setShowChangePasswordPopup(false)
                        setShowSuccessSnackbar(true);
                        window.location.reload()
                        setTimeout(() => {
                            setShowChangePasswordPopup(false);
                        }, 300);
                    } else if (result.status === "400") {
                        setApiError(result.message)
                    }
                }
                )
                .catch(() => {});
            setViewBackdrop(false);
        },
    });
    const filterDivision = (divisionCode) => {
        let itemFound = tableDivision.find(item => item.divisionCode === divisionCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const closeBankDetailsPopup = () => {
        setShowChangePasswordPopup(false);
        setSelectedUserId(null);
        setApiError('');
        bankdetailsFormik.resetForm();
    };

    const onDelete = async () => {
        var formdata = new FormData();
        formdata.append("divisionCode", dltDivision);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteDivision", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableDivision]
                    let index = myArray.findIndex(obj => obj.divisionCode == dltDivision);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableDivision(myArray)
                    }
                }
                else {
                }
            })
            .catch(() => {});
        handleClose2();
    }

    // const tblColumns = [
    //     { field: "id", headerName: 'Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "completename", headerName: 'Division Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "circlename", headerName: 'Circle Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "companyname", headerName: 'Company Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     {
    //         field: "button", headerName: 'Bank Details ', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {
    //             return (
    //                 <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
    //                     <IconButton aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                         <EditNoteIcon sx={{ color: '#e25316ff' }}
    //                             onClick={() => {
    //                                 setSelectedUserId(params.id);
    //                                 setShowChangePasswordPopup(true);
    //                             }}
    //                             alt="Bank Details" style={{ width: '24px', height: '24px' }} />
    //                     </IconButton>
    //                 </div>
    //             )
    //         }
    //     },
    //     {
    //         headerName: "Action",
    //         sortable: false,
    //         field: 'buttons',
    //         align: 'center',
    //         headerStyle: tableStyle.headerStyle,
    //         headerCellStyle: tableStyle.headerCellStyle,
    //         rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {

    //             const onViewDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const item = filterDivision(params.id);
    //                 setDialogRowData(item);
    //                 setOpen(true);
    //             };

    //             const onDeleteDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 setopen2(true);
    //                 setDltDivision(params.id)
    //             }

    //             const onEditDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const divisionToEdit = filterDivision(params.id);
    //                 Navigate('/division-management/update-division', { state: { divisionToEdit } })
    //             }

    //             return (
    //                 <>
    //                     <Box>
    //                         <Box>
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Read') ?
    //                                     <IconButton onClick={onViewDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Update') ?
    //                                     <IconButton onClick={onEditDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Delete') ?
    //                                     <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteDivision}>
    //                                         <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
    //                                     </IconButton> : null
    //                             }
    //                         </Box>
    //                     </Box>
    //                 </>
    //             )
    //         }
    //     }
    // ]
    const tblColumns = [
        { field: "id", headerName: 'Code', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'Division Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "circlename", headerName: 'Circle Code', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "companyname", headerName: 'Company Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

        // ✅ Show only if user has permission
        CheckPermissions(permissions, "Organization Management", "Division Management", "Update Div Bank Details") && {
            field: "button",
            headerName: "Bank Details",
            headerAlign: "center",
            align: "center",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <IconButton aria-label="edit" size="small" sx={{ margin: 0.4, padding: 0 }}>
                        <EditNoteIcon
                            sx={{ color: "#e25316ff" }}
                            onClick={() => {
                                setSelectedUserId(params.id);
                                bankdetailsFormik.setValues({
                                    iv_divisionERPCode: params ? params.erp_code || "" : "",
                                    iv_divBankName: params ? params.bank_name || "" : "",
                                    iv_divCapitalCostAccountNo: params ? params.capital_code || "" : "",
                                    iv_divSecurityAccountNo: params ? params.security_code || "" : "",
                                    iv_remarks: "",
                                });
                                setShowChangePasswordPopup(true);
                            }}
                            alt="Bank Details"
                            style={{ width: "24px", height: "24px" }}
                        />
                    </IconButton>
                </div>
            ),
        },

        {
            headerName: "Action",
            sortable: false,
            field: "buttons",
            headerAlign: "center",
            align: "center",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {
                const onViewDivision = (e) => {
                    e.stopPropagation();
                    const item = filterDivision(params.id);
                    setDialogRowData(item);
                    console.log(item);
                    setOpen(true);
                };

                const onDeleteDivision = (e) => {
                    e.stopPropagation();
                    setopen2(true);
                    setDltDivision(params.id);
                };

                const onEditDivision = (e) => {
                    e.stopPropagation();
                    const divisionToEdit = filterDivision(params.id);
                    Navigate("/division-management/update-division", {
                        state: { divisionToEdit },
                    });
                };

                return (
                    <Box>
                        {CheckPermissions(permissions, "Organization Management", "Division Management", "Read") && (
                            <IconButton onClick={onViewDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <VisibilityIcon sx={{ color: "skyblue" }} fontSize="inherit" />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, "Organization Management", "Division Management", "Update") && (
                            <IconButton onClick={onEditDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <EditIcon fontSize="inherit" sx={{ color: "blue" }} />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, "Organization Management", "Division Management", "Delete") && (
                            <IconButton onClick={onDeleteDivision} size="small" sx={{ margin: 0, padding: 0 }}>
                                <DeleteIcon fontSize="inherit" sx={{ color: "red" }} />
                            </IconButton>
                        )}
                    </Box>
                );
            },
        },
    ].filter(Boolean); // ✅ removes `false` entries

    const apiToDataGridConversion = () => {
        const myArray = tableDivision
        const tempArray = []
        if (myArray) {
            myArray.forEach((item) => {
                const slicedCircleCode = item.circleCode.toString().slice(0, 2);

                const dataGridObject = {
                    "id": item.divisionCode,
                    "completename": item.divisionName ? item.divisionName : '-',
                    // "created_by": item.createdBy ? item.createdBy : '-',
                    // "created_at": item.createdDate ? convertDate(item.createdDate) : '-',
                    // "updated_by": item.updateBy ? item.updateBy : '-',
                    // "updated_at": item.updatedDate ? convertDate(item.updatedDate) : '-',
                    "circlename": item.circleCode ? item.circleCode : "-",
                    "companyname": companyShortName(slicedCircleCode),
                    "bank_name": item.divBankName ? item.divBankName : '-',
                    "erp_code": item.divErpCode ? item.divErpCode : '-',
                    "capital_code": item.divCapitalCostAccountNo ? item.divCapitalCostAccountNo : '-',
                    "security_code": item.divSecurityAccountNo ? item.divSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": " ",
                "completename": " ",
                "created_by": " ",
                "created_at": " ",
                "updated_by": " ",
                "updated_at": " ",
            }
            tempArray.push(dataGridObject)
        }
        setDivisionsToDataGrid(tempArray);
        setFilteredData(tempArray); // keep a filtered copy
    }
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchQuery(value);

        const filtered = divisionsToDataGrid.filter((row) =>
            row.id.toString().toLowerCase().includes(value) ||
        row.completename.toString().toLowerCase().includes(value) ||
        row.circlename.toString().toLowerCase().includes(value) ||
        row.companyname.toString().toLowerCase().includes(value) 
        );

        setFilteredData(filtered);
    };
    return (
        <>
            <Box className='form-box org-management-list'>
                {/* <Box className='main-heading'>
                    <h2>
                        Division Management
                    </h2>
                    <div className='btn2'>
                        {
                            CheckPermissions(permissions,'Organization Management', 'Division Management', 'Create') &&
                            < Link to="/division-management/new-division">
                                <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} sx={{ textTransform: 'capitalize' }} >
                                    Create Division
                                </Button>
                            </Link>
                        }
                    </div>
                </Box> */}
                <Box className="mgmt-page-header">
                    <div className="mgmt-page-header__leading">
                        <h3 className="page-title">Division Management</h3>
                        {isAdminUser && (
                            <AdminCompanySelect
                                value={selectedCompanyCode}
                                onChange={handleChangeCompany}
                                minWidth={180}
                                includePitc={false}
                                restrictToEnabled={false}
                            />
                        )}
                    </div>
                    <div className="mgmt-table-search">
                        <span className="mgmt-table-search__badge" aria-hidden="true">
                            <SearchIcon className="mgmt-table-search__icon" />
                        </span>
                        <input
                            type="text"
                            className="mgmt-table-search__input"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder="Search by Code, Division/Company Name or Circle Code"
                            maxLength={20}
                            aria-label="Search divisions"
                        />
                    </div>
                </Box>
                <Box className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0
                                ? tableStyle.evenRow
                                : tableStyle.oddRow;
                        }}
                    />
                </Box>

            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                className="alert-popups org-details-dialog"
                aria-labelledby="division-details-dialog-title"
            >
                <DialogTitle
                    id="division-details-dialog-title"
                    component="div"
                    className="dialog-title"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <span className="org-details-dialog__title-text">Division Details</span>
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        aria-label="Close division details"
                        className="org-details-dialog__close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <div className="org-details-dialog__body">
                        <div className="org-details-dialog__hero">
                            <div className="org-details-dialog__logo-wrap">
                                <div className="org-details-dialog__avatar" aria-hidden="true">
                                    {(dialogRowData.divisionName || 'D').toString().charAt(0).toUpperCase()}
                                </div>
                            </div>
                            <div className="org-details-dialog__hero-meta">
                                <h2 className="org-details-dialog__name">
                                    {displayValue(dialogRowData.divisionName)}
                                </h2>
                                <p className="org-details-dialog__code">
                                    Division ID: <strong>{displayValue(dialogRowData.divisionCode)}</strong>
                                </p>
                                <span
                                    className={`org-details-dialog__status org-details-dialog__status--${
                                        isDivisionActive(dialogRowData.status) ? 'active' : 'inactive'
                                    }`}
                                >
                                    {isDivisionActive(dialogRowData.status) ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>

                        <DetailSection title="General Information">
                            <DetailField label="Latitude" value={dialogRowData.latitude} />
                            <DetailField label="Longitude" value={dialogRowData.longitude} />
                            <DetailField label="Created By" value={dialogRowData.createdBy} />
                            <DetailField label="Created At" value={formatDetailDate(dialogRowData.createdDate)} />
                            <DetailField label="Last Updated By" value={dialogRowData.updateBy} />
                            <DetailField
                                label="Last Updated At"
                                value={formatDetailDate(dialogRowData.updatedDate)}
                            />
                        </DetailSection>

                        <DetailSection title="Contact Person 1">
                            <DetailField label="Name" value={dialogRowData.cp1Name} />
                            <DetailField label="Phone" value={dialogRowData.cp1phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp1Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp1Email} />
                        </DetailSection>

                        <DetailSection title="Contact Person 2">
                            <DetailField label="Name" value={dialogRowData.cp2Name} />
                            <DetailField label="Phone" value={dialogRowData.cp2phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp2Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp2Email} />
                        </DetailSection>

                        <DetailSection title="Bank Details">
                            <DetailField label="Bank Name" value={dialogRowData.divBankName} />
                            <DetailField label="ERP Code" value={dialogRowData.divErpCode} />
                            <DetailField
                                label="Capital Cost Account No."
                                value={dialogRowData.divCapitalCostAccountNo}
                            />
                            <DetailField
                                label="Security Cost Account No."
                                value={dialogRowData.divSecurityAccountNo}
                            />
                        </DetailSection>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={showChangePasswordPopup}
                onClose={closeBankDetailsPopup}
                fullWidth
                maxWidth="sm"
                className="alert-popups org-details-dialog org-details-dialog--form"
                aria-labelledby="division-bank-details-dialog-title"
            >
                <DialogTitle
                    id="division-bank-details-dialog-title"
                    component="div"
                    className="dialog-title"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <span className="org-details-dialog__title-text">Division Bank Details</span>
                    <IconButton
                        id="clearPopup"
                        onClick={closeBankDetailsPopup}
                        size="small"
                        aria-label="Close bank details"
                        className="org-details-dialog__close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className="dialog-content">
                    <form className="org-details-dialog__form" onSubmit={bankdetailsFormik.handleSubmit}>
                        <div className="org-details-dialog__form-grid">
                            <div className="org-details-dialog__form-field org-details-dialog__form-field--full">
                                <label className="org-details-dialog__form-label">Division Code</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={selectedUserId || ''}
                                    disabled
                                    autoComplete="off"
                                />
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">ERP Code</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_divisionERPCode"
                                    value={bankdetailsFormik.values.iv_divisionERPCode}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_divisionERPCode"
                                />
                                {bankdetailsFormik.errors.iv_divisionERPCode && bankdetailsFormik.touched.iv_divisionERPCode ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_divisionERPCode}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">Bank Name</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_divBankName"
                                    value={bankdetailsFormik.values.iv_divBankName}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_divBankName"
                                />
                                {bankdetailsFormik.errors.iv_divBankName && bankdetailsFormik.touched.iv_divBankName ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_divBankName}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">Capital Cost Account No.</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_divCapitalCostAccountNo"
                                    value={bankdetailsFormik.values.iv_divCapitalCostAccountNo}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_divCapitalCostAccountNo"
                                />
                                {bankdetailsFormik.errors.iv_divCapitalCostAccountNo && bankdetailsFormik.touched.iv_divCapitalCostAccountNo ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_divCapitalCostAccountNo}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">Security Account No.</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_divSecurityAccountNo"
                                    value={bankdetailsFormik.values.iv_divSecurityAccountNo}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_divSecurityAccountNo"
                                />
                                {bankdetailsFormik.errors.iv_divSecurityAccountNo && bankdetailsFormik.touched.iv_divSecurityAccountNo ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_divSecurityAccountNo}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field org-details-dialog__form-field--full">
                                <label className="org-details-dialog__form-label">Remarks</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_remarks"
                                    value={bankdetailsFormik.values.iv_remarks}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_remarks"
                                />
                                {bankdetailsFormik.errors.iv_remarks && bankdetailsFormik.touched.iv_remarks ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_remarks}</p>
                                ) : null}
                            </div>
                            {apiError ? (
                                <div className="org-details-dialog__form-field org-details-dialog__form-field--full">
                                    <Error
                                        error={apiError}
                                        onClose={() => errorCloses()}
                                        backgroundColor="#FFC0CB"
                                        textColor="#bb0303"
                                        iconColor="#bb0303"
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div className="org-details-dialog__form-actions">
                            <Button
                                type="submit"
                                variant="contained"
                                size="medium"
                                className="org-details-dialog__submit-btn"
                            >
                                Submit
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>

            <Snackbar
                open={showSuccessSnackbar}
                autoHideDuration={3000}
                onClose={() => setShowSuccessSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            >
                <Alert
                    onClose={() => setShowSuccessSnackbar(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Bank Details Saved.
                </Alert>
            </Snackbar>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >
        </>
    )
}
